import { axios } from '@/utils/request'

const api = {
  accessory: '/enterprise/enterpriseAccessory',
  company: '/enterprise/management',
  brand: '/enterprise/brand',
  model: '/enterprise/model',
  store: '/stock/store'
}

export function getAccessoryList (parameter) {
  return axios({
    url: api.accessory + '/getUseEnterpriseAccessory',
    method: 'get',
    params: parameter
  })
}

export function queryEnterpriseStock (parameter) {
  return axios({
    url: api.accessory + '/queryEnterpriseStock',
    method: 'get',
    params: parameter
  })
}
//可分配仓库
export function getEnterpriseAccessory (parameter) {
  return axios({
    url: api.accessory + '/getEnterpriseAccessory',
    method: 'get',
    params: parameter
  })
}
//已分配仓库
export function queryAssignEnterpriseStock (parameter) {
  return axios({
    url: api.accessory + '/queryAssignEnterpriseStock',
    method: 'get',
    params: parameter
  })
}
// 修改配件金额，费用承担方
export function editEnterpriseAccessory (parameter) {
  return axios({
    url: api.accessory + '/editEnterpriseAccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 新增通用配件
export function addCommonEnterpriseAccessory (parameter) {
  return axios({
    url: api.accessory + '/addCommonEnterpriseAccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 企业名单
export function getSlectCombox (parameter) {
  return axios({
    url: api.company + '/selectCombox',
    method: 'get',
    params: parameter
  })
}
// 品牌
export function getSelectBrand (parameter) {
  return axios({
    url: api.brand + '/selectBrand',
    method: 'get',
    params: parameter
  })
}
// 型号
export function getModelNumber (parameter) {
  return axios({
    url: api.model + '/selectModel',
    method: 'get',
    params: parameter
  })
}
// 配件
export function selectAccessoryNameCombox (parameter) {
  return axios({
    url: api.accessory + '/selectAccessoryNameCombox',
    method: 'get',
    params: parameter
  })
}
// 新建跳转 配件型号
export function queryEnterpriseAccessoryModel (parameter) {
  return axios({
    url: api.accessory + '/queryEnterpriseAccessoryModel',
    method: 'get',
    params: parameter
  })
}
// 编辑跳转 配件型号
export function queryEnterpriseAccessoryModelExclude (parameter) {
  return axios({
    url: api.accessory + '/queryEnterpriseAccessoryModelExclude',
    method: 'get',
    params: parameter
  })
}
// 配置提交 未选中的
export function relateModelEnterpriseAccessory (parameter) {
  return axios({
    url: api.accessory + '/relateModelEnterpriseAccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function selectAccessoryTypeCombox (parameter) {
  return axios({
    url: api.accessory + '/selectAccessoryTypeCombox',
    method: 'get',
    params: parameter
  })
}

export function selectAccessoryCategoryCombox (parameter) {
  return axios({
    url: api.accessory + '/selectAccessoryCategoryCombox',
    method: 'get',
    params: parameter
  })
}

export function selectAccessorySpecificationCombox (parameter) {
  return axios({
    url: api.accessory + '/selectAccessorySpecificationCombox',
    method: 'get',
    params: parameter
  })
}

// 仓库
export function selectStoreCombox (parameter) {
  return axios({
    url: api.store + '/selectStoreCombox',
    method: 'get',
    params: parameter
  })
}
// 分配仓库
export function assignEnterpriseStock (parameter) {
  return axios({
    url: api.accessory + '/assignEnterpriseStock',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function saveAccessory (parameter) {
  return axios({
    url: api.accessory + (parameter.accessoryId > 0 ? '/update' : '/save'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delAccessory (parameter) {
  return axios({
    url: api.accessory + '/deleteEnterpriseAccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 禁用
export function getForbiddenAccessory (parameter) {
  return axios({
    url: api.accessory + '/forbiddenEnterpriseAccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 启动
export function getEnableAccessory (parameter) {
  return axios({
    url: api.accessory + '/enableEnterpriseAccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const accessoryExport = api.accessory + '/export'
